module.exports = __webpack_public_path__ + "static/media/danceoff.8f298f1e.png";